import { jsx as r, jsxs as d, Fragment as s } from "react/jsx-runtime";
import { useBreakpoint as g, NextgenImage as b, LoaderType as m, GenericLink as k, Button as z, ButtonStyles as f, Theme as V, ButtonSize as C } from "@nextgen-web-framework/all";
import p from "./components/SkeletonLoader/SkeletonLoader.js";
import { getGradientClass as y } from "./utils/themeColor.js";
import { Gradient as B } from "./components/heroBanner/types/propsTypes.js";
import './assets/HeroComponentItem.css';const G = "#ffffff", v = "#396e75", N = "#e5fdff", O = "#546223", T = "#f0fae5", w = "#a65523", S = "#fff1e8", W = "#7f3e3e", x = "#ffe2e2", R = "#62625a", L = "#f8f8e7", Y = "#38539a", A = "#707070", E = "#c8f8d1", H = "#87c9c8", P = "#5291b1", j = "rgba(82, 145, 177, 0.1019607843)", D = "#445685", M = "#181d61", U = "rgba(24, 29, 97, 0.1019607843)", $ = "#5969d6", F = "#ea999d", K = "#b6577e", q = "rgba(182, 87, 126, 0.1019607843)", J = "#7e3e80", Q = "#1e247f", X = "rgba(30, 36, 127, 0.1019607843)", Z = "#da7600", I = "#107f47", ee = "#d91734", re = "_html_1u80n_46", t = {
  amwayWhite: G,
  darkBlue: v,
  lightBlue: N,
  darkGreen: O,
  lightGreen: T,
  darkOrange: w,
  lightOrange: S,
  darkRed: W,
  lightRed: x,
  darkYellow: R,
  lightYellow: L,
  darkPurple: Y,
  darkGrayOnWhite: A,
  dataVizColor1: E,
  dataVizColor2: H,
  dataVizColor3: P,
  dataVizColor3Background: j,
  dataVizColor4: D,
  dataVizColor5: M,
  dataVizColor5Background: U,
  dataVizColor6: $,
  dataVizColor7: F,
  dataVizColor8: K,
  dataVizColor8Background: q,
  dataVizColor9: J,
  dataVizColor10: Q,
  dataVizColor10Background: X,
  dataVizAlertOrange: Z,
  dataVizSuccessGreen: I,
  dataVizWarningRed: ee,
  "no-visible": "_no-visible_1u80n_42",
  html: re,
  "theme-border-dark-red": "_theme-border-dark-red_1u80n_159",
  "theme-border-dark-blue": "_theme-border-dark-blue_1u80n_163",
  "theme-border-dark-orange": "_theme-border-dark-orange_1u80n_167",
  "theme-border-dark-green": "_theme-border-dark-green_1u80n_171",
  "theme-border-dark-purple": "_theme-border-dark-purple_1u80n_175",
  "theme-border-dark-gray": "_theme-border-dark-gray_1u80n_179",
  "theme-border-light-red": "_theme-border-light-red_1u80n_183",
  "theme-border-light-blue": "_theme-border-light-blue_1u80n_187",
  "theme-border-light-orange": "_theme-border-light-orange_1u80n_191",
  "theme-border-light-green": "_theme-border-light-green_1u80n_195",
  "theme-border-light-purple": "_theme-border-light-purple_1u80n_199",
  "theme-border-light-gray": "_theme-border-light-gray_1u80n_203",
  "theme-gradient-red": "_theme-gradient-red_1u80n_207",
  "theme-gradient-blue": "_theme-gradient-blue_1u80n_211",
  "theme-gradient-orange": "_theme-gradient-orange_1u80n_215",
  "theme-gradient-green": "_theme-gradient-green_1u80n_219",
  "theme-gradient-purple": "_theme-gradient-purple_1u80n_223",
  "hero-banner-carousel-container": "_hero-banner-carousel-container_1u80n_227",
  "hero-banner-container": "_hero-banner-container_1u80n_231",
  "hero-banner-bg-image": "_hero-banner-bg-image_1u80n_246",
  "blue-gradient": "_blue-gradient_1u80n_250",
  "red-gradient": "_red-gradient_1u80n_253",
  "maroon-gradient": "_maroon-gradient_1u80n_256",
  "orange-gradient": "_orange-gradient_1u80n_259",
  "green-gradient": "_green-gradient_1u80n_262",
  "purple-gradient": "_purple-gradient_1u80n_265",
  "hero-banner-bottom-content-container": "_hero-banner-bottom-content-container_1u80n_268",
  "hero-content": "_hero-content_1u80n_280",
  "hero-banner-title": "_hero-banner-title_1u80n_289",
  "hero-banner-sub-title": "_hero-banner-sub-title_1u80n_305",
  "hero-banner-button": "_hero-banner-button_1u80n_321",
  "skeleton-loading": "_skeleton-loading_1u80n_1"
}, ie = (e) => {
  var i, l, h;
  const c = g(), u = e.linearGradient ? y(e.linearGradient) : e.overlayGradient ? B[e.overlayGradient] : "", o = e == null ? void 0 : e.imageList.find((a) => {
    var _;
    return (_ = a == null ? void 0 : a.viewport) == null ? void 0 : _.includes(c);
  });
  let n = "";
  return o && (n = o.url), /* @__PURE__ */ r("div", { className: t["hero-banner-container"], "data-testid": "hero-banner-testid", "data-pod-name": "commerce", children: n && o ? /* @__PURE__ */ d(s, { children: [
    /* @__PURE__ */ r(
      b,
      {
        src: n,
        alt: o.altText,
        className: t["hero-banner-bg-image"],
        loading: "eager",
        loaderType: m.CONTENTSTACK
      }
    ),
    /* @__PURE__ */ d("div", { className: `${t["hero-banner-bottom-content-container"]} ${t[u]}`, children: [
      /* @__PURE__ */ d("div", { className: t["hero-content"], children: [
        /* @__PURE__ */ r("h2", { className: t["hero-banner-title"], children: e == null ? void 0 : e.title }),
        /* @__PURE__ */ r("h4", { className: t["hero-banner-sub-title"], children: e == null ? void 0 : e.subTitle })
      ] }),
      /* @__PURE__ */ r("div", { className: t["hero-banner-button"], children: /* @__PURE__ */ r(k, { href: (i = e == null ? void 0 : e.redirectionInfo) == null ? void 0 : i.url, target: (l = e == null ? void 0 : e.redirectionInfo) == null ? void 0 : l.target, children: /* @__PURE__ */ r(
        z,
        {
          title: (h = e == null ? void 0 : e.redirectionInfo) == null ? void 0 : h.text,
          buttonStyle: f.SOLID,
          theme: V.WHITE,
          size: C.MEDIUM,
          "data-testid": "hero-banner-button-testid",
          "data-pod-name": "commerce"
        }
      ) }) })
    ] })
  ] }) : /* @__PURE__ */ r(p, { height: 605 }) });
};
export {
  ie as H,
  t as s
};
//# sourceMappingURL=HeroComponentItem-49e04925.mjs.map
